// External modules
import React, { useEffect, useRef, useState } from 'react';

// Internal modules
import { getContent } from '@/lib';
import {
  ChangeFieldContainer,
  ChangeFieldTextButton,
  ChangeFieldValue,
} from './StyledComponents';

interface ValueAsFieldLabelProps {
  value?: string;
  children: ({ shouldAutoFocus }: { shouldAutoFocus: boolean }) => JSX.Element;
  shouldRenderAsValue?: boolean;
  onClick: () => void;
}

const ValueAsFieldLabel = ({
  value,
  children,
  shouldRenderAsValue = false,
  onClick,
}: ValueAsFieldLabelProps): React.ReactElement => {
  const [isValue, setIsValue] = useState<boolean>(shouldRenderAsValue);
  const shouldAutoFocus = useRef<boolean>(false);

  useEffect(() => {
    setIsValue(shouldRenderAsValue);
  }, [shouldRenderAsValue]);

  const handleChangeButtonClick = () => {
    setIsValue(false);
    shouldAutoFocus.current = true;
    onClick();
  };

  if (isValue) {
    return (
      <ChangeFieldContainer paddingTop="10px">
        <ChangeFieldValue>{value}</ChangeFieldValue>
        <ChangeFieldTextButton
          aria-expanded="false"
          onClick={handleChangeButtonClick}
        >
          {getContent('base.change')}
        </ChangeFieldTextButton>
      </ChangeFieldContainer>
    );
  }
  return children({ shouldAutoFocus: shouldAutoFocus.current });
};

export { ValueAsFieldLabel };
